import { get, post } from '@/request/request';

export default {
  list(params) {
    return get('/admin/doc/expense/claim/list', params);
  },
  info(params) {
    return get('/admin/doc/expense/claim/info', params);
  },
  save(params) {
    return post('/admin/doc/expense/claim/save', params);
  },
  delete(params) {
    return post('/admin/doc/expense/claim/delete', params);
  }
};
